import script from "./ModalTpsl.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalTpsl.vue?vue&type=script&setup=true&lang=js"

import "./ModalTpsl.vue?vue&type=style&index=0&id=4e61cdc6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e61cdc6"]])

export default __exports__